import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const Authmiddleware = ({ children }) => {
  const location = useLocation();
  const accessToken = sessionStorage.getItem("accessToken");
  const userDataString = sessionStorage.getItem("userData");
  let businessProfile = null;
  let subcriptionActive = false;

  if (userDataString) {
    try {
      const userData = JSON.parse(userDataString);
      businessProfile = userData?.authUser?.businessProfile;
      subcriptionActive = userData?.subcriptionActive;

    } catch (e) {
      console.error("Invalid userData in sessionStorage:", e);
    }
  }

  if (!accessToken || businessProfile !== "business" || subcriptionActive === false) {
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }

  if (businessProfile === "business") {
    return (
      <>
        {children}
      </>
    );
  }

};
const AlexxcansolsAuthmiddleware = ({ children }) => {
  const location = useLocation();
  const accessToken = sessionStorage.getItem("accessToken");
  const userDataString = sessionStorage.getItem("userData");

  let businessProfile = null;
  if (userDataString) {
    try {
      const userData = JSON.parse(userDataString);
      businessProfile = userData?.authUser?.businessProfile;
    } catch (e) {
      console.error("Invalid userData in sessionStorage:", e);
    }
  }
  if (!accessToken || businessProfile !== "owner") {
    return (
      <Navigate
        to="/alexxcansols"
        state={{ from: location }}
        replace
      />
    );
  }
  if (businessProfile === "owner") {
    return (
      <>
        {children}
      </>
    );
  }
};
const PartnerAuthmiddleware = ({ children }) => {
  const location = useLocation();
  const accessToken = sessionStorage.getItem("accessToken");
  const userDataString = sessionStorage.getItem("userData");

  let businessProfile = null;
  if (userDataString) {
    try {
      const userData = JSON.parse(userDataString);
      businessProfile = userData?.authUser?.businessProfile;
    } catch (e) {
      console.error("Invalid userData in sessionStorage:", e);
    }
  }
  if (!accessToken || businessProfile !== "partner") {

    return (
      <Navigate
        to="/partner"
        state={{ from: location }}
        replace
      />
    );
  }
  if (businessProfile === "partner") {
    return (
      <>
        {children}
      </>
    );
  }
};

export { Authmiddleware, AlexxcansolsAuthmiddleware, PartnerAuthmiddleware };
